<template>
  <div class="d-flex">
    <button class="prev-btn p-0 ml-2" :disabled="disablePrev" :aria-label="prev" @click="choosePrev">
      <svg class="icon icon-hsy-icon-angle-right-small-bold"><use xlink:href="#icon-hsy-icon-angle-right-small-bold"></use></svg>
    </button>
    <h4 class="font-weight-bold px-3 my-0">
    {{ selectedYear }}
    </h4>
    <button class="next-btn p-0" :disabled="disableNext" :aria-label="next" @click="chooseNext">
      <svg class="icon icon-hsy-icon-angle-left-small-bold"><use xlink:href="#icon-hsy-icon-angle-left-small-bold"></use></svg>
    </button>
  </div>     
</template>

<script>

    export default {
        props: {
            label: {
                type: String,
                required: false,
                default: ""
            },
            next: {
              type: String,
              required: false,
              default: ""
            },
            prev: {
              type: String,
              required: false,
              default: ""
            },
            years: {
                type: Array,
                required: true
            },
            currentYear: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                index: 0,
                disablePrev: false,
                disableNext: false,
                year: ""
            }
        },
        computed: {
            selectedYear: {
                get: function () {
                    return this.year;
                },
                set: function (value) {
                    this.year = value;
                    this.$emit("change-year", value);
                }
            }
        },
        mounted() {
            this.index = this.years.findIndex((year) => {
              return this.currentYear == year;
            });
            this.selectedYear = this.years[this.index];
            this.setButtons();
        },
        methods: {
            choosePrev() {
              this.index -= 1;
              this.selectedYear = this.years[this.index];
              this.setButtons();
            },
            chooseNext() {
              this.index += 1;
              this.selectedYear = this.years[this.index];
              this.setButtons();
            },
            setButtons() {
              this.disablePrev = this.years[this.index - 1] == undefined;
              this.disableNext = this.years[this.index + 1] == undefined;
            }
        }
    }
</script>